import type { ManagedBlockGoal, ManagedBlockOutputFormat } from './types';

export const DEFAULT_OUTPUT_FORMAT: ManagedBlockOutputFormat = 'text';
export const SYSTEM_DESIGN_OUTPUT_FORMAT: ManagedBlockOutputFormat = 'diagram';

export const isOutputFormat = (value: unknown): value is ManagedBlockOutputFormat =>
	value === 'diagram' ||
	value === 'list' ||
	value === 'panel' ||
	value === 'table' ||
	value === 'text';

export const getOutputFormatForGoal = (
	goal: ManagedBlockGoal,
	outputFormat: unknown,
): ManagedBlockOutputFormat => {
	if (goal === 'system-design') {
		return SYSTEM_DESIGN_OUTPUT_FORMAT;
	}

	return isOutputFormat(outputFormat) && outputFormat !== SYSTEM_DESIGN_OUTPUT_FORMAT
		? outputFormat
		: DEFAULT_OUTPUT_FORMAT;
};
